import { useRouter } from "next/router";
import qs from "query-string";
import { getHrefAndPath } from "../../util/url/getHrefAndPath";

const INITIAL_PAGE = 1;

export function validPageNo(pageNumber: any) {
  try {
    return parseInt(pageNumber, 10);
  } catch (err) {
    return INITIAL_PAGE;
  }
}

function useCategoryActions(url: any) {
  const router = useRouter();

  function updatePage(newPageNo: any, newSortBy: any) {
    const queryString = qs.stringify({
      sizes: router.query.sizes, // for tires size pages i.e /tires/205-55R16
      ...qs.parse(location.search),
      pathname: undefined,
      scroll: undefined,
      pageNumber: newPageNo === INITIAL_PAGE ? undefined : newPageNo,
      sortBy: newSortBy === "relevance" ? undefined : newSortBy,
    });

    const { href, asPath } = getHrefAndPath({ queryString, href: url, asPath: router.query.pathname || router.pathname });
    router.push(href, asPath)
      .then(() => window.scrollTo(0, 0));
  }

  function onChangeSortBy(sortByValue: any) {
    updatePage(1, sortByValue, true);
  }

  function onSelectPage(newPage: any, event: any) {
    // pagination of TIER_MAKE_MODEL_PAGES have links, so make preventDefault link
    if (event) {
      event.preventDefault();
    }

    updatePage(newPage, router.query.sortBy, true);
  }

  return {
    onChangeSortBy,
    onSelectPage,
  };
}
export default useCategoryActions;
